define([
	'internal_util/Util',
	'model/AuthenticationOption',
	'view/AuthenticationOptionView',
	'view/UIView',
	'lib/jquery'
], function (
	Util,
	AuthenticationOption,
	AuthenticationOptionView,
	UIView,
	jQuery
) {
	'use strict';

	/**
	 * ControlView class
	 */
	return function (authenticationOptionCallback) {
		var _authenticationOptionCallback = authenticationOptionCallback,
			_authenticationOptions,
			_authenticationOptionViews,
			_view = jQuery("<div id='skIdS_control-container' class='skIdS_content-body'></div>");


		// private methods

		function getAuthenticationOptionView(authenticationOption) {
			for (var i = 0; i < _authenticationOptions.length; i++) {
				if (_authenticationOptions[i] === authenticationOption) {
					return _authenticationOptionViews[i];
				}
			}

			return null;
		}


		// public methods

		this.get = function () {
			return _view;
		};

		this.update = function (authenticationOptions, noOptionsText, forceCloudID) {
			var authenticationOptionView,
				i;

			if (Util.isArray(authenticationOptions)) {
				_authenticationOptions = authenticationOptions;
			} else if (authenticationOptions instanceof AuthenticationOption){
				_authenticationOptions = [ authenticationOptions ];
			} else {
				throw new Error('invalid authenticationOptions');
			}

			if (typeof _authenticationOptionViews === 'undefined'
						|| _authenticationOptionViews.length === 0) {
				_view.children().detach();
			} else {
				_view.empty();
			}

			_authenticationOptionViews = new Array();

			if (_authenticationOptions.length === 0) {
				if (noOptionsText instanceof UIView) {
					_view.append(noOptionsText.get());
				} else {
					_view.append(noOptionsText);
				}

				_view.addClass('skIdS_control-container-iefix');
			} else {
				for (i = 0; i < _authenticationOptions.length; i++) {
					authenticationOptionView = new AuthenticationOptionView();

					authenticationOptionView.update(_authenticationOptions[i], forceCloudID);

					authenticationOptionView.get().one('click', (function (authenticationOption) {
						return function () {
							Util.callCallbacks(_authenticationOptionCallback, authenticationOption);
						};
					})(_authenticationOptions[i]));

					_authenticationOptionViews.push(authenticationOptionView);

					_view.append(authenticationOptionView.get());
				}
			}
		};

		this.enableAuthenticationOption = function (authenticationOption, animate) {
			var authenticationOptionView = getAuthenticationOptionView(authenticationOption);

			if (authenticationOptionView !== null) {
				authenticationOptionView.enable(animate);
			}
		};

		this.disableAuthenticationOption = function (authenticationOption, animate) {
			var authenticationOptionView = getAuthenticationOptionView(authenticationOption);

			if (authenticationOptionView !== null) {
				authenticationOptionView.disable(animate);
			}
		};

		this.enableAuthenticationOptionToolTip = function (authenticationOption, message) {
			var authenticationOptionView = getAuthenticationOptionView(authenticationOption);

			if (authenticationOptionView !== null) {
				authenticationOptionView.enableToolTip(message);
			}
		};

		this.disableAuthenticationOptionToolTip = function (authenticationOption) {
			var authenticationOptionView = getAuthenticationOptionView(authenticationOption);

			if (authenticationOptionView !== null) {
				authenticationOptionView.disableToolTip();
			}
		};

		this.enableAuthenticationOptionCallback = function (authenticationOption) {
			var authenticationOptionView = getAuthenticationOptionView(authenticationOption);

			if (authenticationOptionView !== null) {
				authenticationOptionView.get().off('click');
				authenticationOptionView.get().one('click', function () {
					Util.callCallbacks(_authenticationOptionCallback, authenticationOption);
				});
			}
		};

		this.disableAuthenticationOptionCallback = function (authenticationOption) {
			var authenticationOptionView = getAuthenticationOptionView(authenticationOption);

			if (authenticationOptionView !== null) {
				authenticationOptionView.get().off('click');
			}
		};
	};
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/view/ControlView.js
// module id = 41
// module chunks = 1